export interface QUANTITY_Interface {
  id:number,
  title:String,
  parent:number,
  parentTitle:String,
  del:boolean,
  certificate_id:number,
  dataentity_id:number,
  child:Array<QUANTITY_Interface>
}

export function Empty_QUANTITY_Interface(){
  return{
    id:0,
    title:'',
    parent:0,
    certificate_id:0,
    dataentity_id:0,
    parentTitle:'',
    del:false,
    child:[]
  }
}
